import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { MEETINGS_PRESET_IDS } from 'constants/meetings';
import { useUpcomingPreset } from 'features/meetings/hooks/use_upcoming_preset';
import { EndOfListContainer } from './styles';
const loadMoreButtonWrapperIsUpcomingCss = "l19odkyy";
const loadMoreButtonWrapperIsPastCss = "lxw77jm";
const loadMoreButtonWrapperCss = "l8awlzn";
const LoadMoreButtonWrapper = forwardRef((props, ref) => {
  const {
    isUpcoming,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(loadMoreButtonWrapperCss, {
    [loadMoreButtonWrapperIsUpcomingCss]: isUpcoming,
    [loadMoreButtonWrapperIsPastCss]: !isUpcoming
  }, props.className)} />;
});
const LoadMoreButton = ({
  isUpcoming,
  onClick,
  isLoading
}) => <LoadMoreButtonWrapper isUpcoming={isUpcoming}>
    <Button onClick={onClick} disabled={isLoading} appearance="secondary-outline" loading={isLoading}>
      {I18n.t('publisher.meetings.end_of_list.view_more')}
    </Button>
  </LoadMoreButtonWrapper>;
const TopMessage = () => <EndOfListContainer>
    <BodyText size="medium" color="muted">
      {I18n.t('publisher.meetings.end_of_list.no_past')}
    </BodyText>
  </EndOfListContainer>;

// i18n-tasks-use t('publisher.meetings.end_of_list.no_more_today')
// i18n-tasks-use t('publisher.meetings.end_of_list.no_more_this_week')
// i18n-tasks-use t('publisher.meetings.end_of_list.no_more_last_week')
const END_OF_LIST_MESSAGE_BY_PRESET = {
  [MEETINGS_PRESET_IDS.TODAY]: 'publisher.meetings.end_of_list.no_more_today',
  [MEETINGS_PRESET_IDS.THIS_WEEK]: 'publisher.meetings.end_of_list.no_more_this_week',
  [MEETINGS_PRESET_IDS.LAST_WEEK]: 'publisher.meetings.end_of_list.no_more_last_week'
};

/** Bounded presets whose lists can be entirely past (esp. Last week), so they cannot rely on hasFutureEvents. */
const PERIOD_END_OF_LIST_PRESETS = new Set([MEETINGS_PRESET_IDS.TODAY, MEETINGS_PRESET_IDS.THIS_WEEK, MEETINGS_PRESET_IDS.LAST_WEEK]);
const getBottomMessageKey = activePreset => END_OF_LIST_MESSAGE_BY_PRESET[activePreset] || 'publisher.meetings.end_of_list.no_more_upcoming';
const BottomMessage = ({
  activePreset
}) => <EndOfListContainer>
    <BodyText size="medium" color="muted">
      {I18n.t(getBottomMessageKey(activePreset))}
    </BodyText>
  </EndOfListContainer>;
export const Bookend = ({
  hasMore,
  isUpcoming,
  anyFutureMeetings,
  ...props
}) => {
  const {
    activePreset
  } = useUpcomingPreset();
  if (!hasMore) {
    if (!isUpcoming) {
      return <TopMessage />;
    }

    // Upcoming still gates on anyFutureMeetings so NO_FUTURE_MEETINGS owns the empty case.
    // Period presets always show end-of-list copy once the bounded list is fully loaded.
    if (PERIOD_END_OF_LIST_PRESETS.has(activePreset) || anyFutureMeetings) {
      return <BottomMessage activePreset={activePreset} />;
    }
    return null;
  }
  return <LoadMoreButton isUpcoming={isUpcoming} {...props} />;
};

require("./bookend.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./bookend.js");